import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { useSelector, useDispatch } from "react-redux";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { inventoryHistoryActions } from "../../../_store";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";

const MRHistoryReport = () => {
  const dispatch = useDispatch();

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------

  const MRHistoryListReport = useSelector(
    (x) => x.inventoryHistory.MRHistoryListReport
  );

  // #endregion ------------------  Reducer End --------------------------------
  const [finalTableData, setFinalTableData] = useState([]);
  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  useEffect(() => {
    dispatch(inventoryHistoryActions.getMRHistoryReport());
  }, [dispatch]);

  const COLUMNS = [
    {
      Header: "Purchase Order #",
      Footer: "Purchase Order #",
      accessor: "PurchaseOrderNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Invoice Number",
      Footer: "Invoice Number",
      accessor: "InvoiceNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString", // from SQL: CONVERT(VARCHAR(10), MR.CreatedDate, 101)
      justify: "center",
      Filter: ColumnFilter,
      fieldType: "Date",
    },
    {
      Header: "Created By",
      Footer: "Created By",
      accessor: "CreatedByName",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Warehouse",
      Footer: "Warehouse",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Vendor",
      Footer: "Vendor",
      accessor: "Vendor",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Filter: ColumnFilter,
    },
  ];

  const generateColumns = [
    { header: "Purchase Order #", dataKey: "PurchaseOrderNumber" },
    { header: "Invoice Number", dataKey: "InvoiceNumber" },
    { header: "Created Date", dataKey: "CreatedDateString" },
    { header: "Created By", dataKey: "CreatedByName" },
    { header: "Warehouse", dataKey: "WareHouseNumber" },
    { header: "Vendor", dataKey: "Vendor" },
    { header: "Status", dataKey: "StatusName" },
  ];

  const generateExcelColumns = [
    "Purchase Order #",
    "Invoice Number",
    "Created Date",
    "Created By",
    "Warehouse",
    "Vendor",
    "Status",
  ];

  const columnStyles = {
    PurchaseOrderNumber: { halign: "center", cellWidth: 40 },
    InvoiceNumber: { halign: "center", cellWidth: 40 },
    CreatedDateString: { halign: "center", cellWidth: 30 },
    CreatedByName: { halign: "center", cellWidth: 40 },
    WareHouseNumber: { halign: "center", cellWidth: 30 },
    Vendor: { halign: "center", cellWidth: 35 },
    StatusName: { halign: "center", cellWidth: 30 },
  };

  let new_MRHistoryListReport =
    finalTableData &&
    finalTableData.map((obj) => {
      return {
        PurchaseOrderNumber: obj.PurchaseOrderNumber,
        InvoiceNumber: obj.InvoiceNumber,
        CreatedDateString: obj.CreatedDateString,
        CreatedByName: obj.CreatedByName,
        WareHouseNumber: obj.WareHouseNumber,
        Vendor: obj.Vendor,
        StatusName: obj.StatusName,
      };
    });

  const handleClickPDF = () => {
    let title = "Merchandise Reception History Report";

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Merchandise Reception History Report";
    generateXlsx(new_MRHistoryListReport, generateExcelColumns, title);
  };

  const columns = useMemo(() => COLUMNS, []);

  return (
    <>
      <PageTitle
        activeMenu="Merchandise Reception History Report"
        motherMenu="Inventory"
      />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">
            Merchandise Reception History Report
          </h4>
          <div className="float-sm-end">
            <Button
              className="me-2"
              variant="danger btn-rounded"
              onClick={handleClickPDF}
            >
              <span className="btn-icon-start text-danger">
                <i className="fa fa-solid fa-file-pdf"></i>
                {/* <i className="fa fa-regular fa-file-excel"></i> */}
              </span>
              PDF
            </Button>
            <Button
              className="me-2"
              variant="secondary btn-rounded"
              onClick={handleClickExcel}
            >
              <span className="btn-icon-start text-secondary">
                {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                <i className="fa fa-regular fa-file-excel"></i>
              </span>
              Excel
            </Button>
          </div>
        </div>
        <div className="card-body">
          <div className="row"></div>
          <Table
            columns={columns}
            data={MRHistoryListReport}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>

      {loader}
    </>
  );
};

export default MRHistoryReport;
